import React from 'react'
import { Redirect } from 'react-router-dom'

export default class Welcome extends React.Component {
  render () {
    return <Redirect to='/1' />
  }
}
